export const Divider = () => {
    return <hr className="w-full h-[1px]bg-primary-black/20" />;
};
